module.exports = __webpack_public_path__ + "img/avatars.64b50ba6.jpg";